// Get Trade Supply form — submits to Shopify's native contact form (real
// server-side email delivery, no mailto/WhatsApp handoff). The custom fields
// below aren't part of Shopify's contact schema, so we fold them into the
// hidden contact[body] field as one formatted message just before submit.
(function () {
  const chipGroups = {};

  function initChipGroup(id) {
    const el = document.getElementById(id);
    if (!el) return;
    chipGroups[id] = null;
    el.querySelectorAll(".filter-chip").forEach(btn => {
      btn.addEventListener("click", () => {
        const isActive = btn.classList.contains("nosh-active");
        el.querySelectorAll(".filter-chip").forEach(b => b.classList.remove("nosh-active"));
        if (!isActive) {
          btn.classList.add("nosh-active");
          chipGroups[id] = btn.dataset.value;
        } else {
          chipGroups[id] = null;
        }
      });
    });
  }

  function val(id) {
    const el = document.getElementById(id);
    return el ? el.value.trim() : "";
  }

  function radioVal(name) {
    const checked = document.querySelector('input[name="' + name + '"]:checked');
    return checked ? checked.value : "";
  }

  function buildMessage() {
    const lines = [
      "Hi Nosh Produce, we'd like to register for trade supply.",
      "",
      "Which best describes you: " + (radioVal("customerType") || "—"),
      "",
      "Restaurant name: " + (val("f-company") || "—"),
      "UEN: " + (val("f-uen") || "—"),
      "Business type: " + (chipGroups.bizType || "—"),
      "Delivery address: " + (val("f-address") || "—"),
      "",
      "Contact: " + (val("f-name") || "—") + (chipGroups.roleType ? " · " + chipGroups.roleType : ""),
      "Mobile: " + (val("f-phone") || "—"),
      "Email: " + (val("f-email") || "—"),
    ];
    const notes = val("f-notes");
    if (notes) lines.push("", "Anything else: " + notes);
    return lines.join("\n");
  }

  // Falls back to English if the i18n bridge script (see
  // nosh-get-started-content.liquid) is ever missing for some reason.
  const i18n = window.noshEnquiryI18n || {};
  const REQUIRED_FIELDS = [
    { id: "f-company", label: i18n.fieldRestaurantName || "restaurant name" },
    { id: "f-uen", label: i18n.fieldUen || "UEN" },
    { id: "f-name", label: i18n.fieldYourName || "your name" },
    { id: "f-email", label: i18n.fieldEmail || "email" },
    { id: "f-phone", label: i18n.fieldMobile || "mobile number" },
  ];

  function validate() {
    return REQUIRED_FIELDS.filter(field => !val(field.id));
  }

  function setFieldError(input, hasError) {
    const wrapper = input.closest(".nosh-field");
    if (wrapper) wrapper.classList.toggle("nosh-field--error", hasError);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initChipGroup("bizType");
    initChipGroup("roleType");

    const form = document.getElementById("enquiryForm");
    const hint = document.getElementById("formHint");
    const restOfForm = document.getElementById("restOfForm");
    const grabRedirect = document.getElementById("grabRedirect");
    const bodyField = document.getElementById("contact-body-field");
    const customerTypeRadios = document.querySelectorAll('input[name="customerType"]');

    // restOfForm/grabRedirect only exist pre-submission — after Shopify
    // redirects back with the success panel, this whole block is skipped.
    if (restOfForm && grabRedirect) {
      function updateCustomerTypeView() {
        const checked = Array.from(customerTypeRadios).find(r => r.checked);
        const mode = checked ? checked.dataset.mode : null;
        restOfForm.classList.toggle("visible", mode === "trade");
        grabRedirect.classList.toggle("visible", mode === "grab");
      }
      customerTypeRadios.forEach(r => r.addEventListener("change", updateCustomerTypeView));
    }

    if (form && bodyField) {
      // Disabling the button itself — not just reacting to the submit event
      // — is the real guard here. Shopify's own reCAPTCHA challenge (shown
      // automatically on this native contact form when it suspects spam,
      // e.g. a submit attempt with everything left blank) completes by
      // calling the form's submit() method directly, which bypasses any
      // "submit" event listener entirely, ours included — so a visitor
      // could solve the captcha and have an incomplete enquiry go through
      // regardless of what our own validation said. A disabled button can't
      // be clicked in the first place, so neither our check nor Shopify's
      // captcha flow ever gets triggered until the form is genuinely
      // complete.
      const submitBtn = form.querySelector('button[type="submit"]');
      const submitRow = submitBtn ? submitBtn.closest(".submit-row") : null;

      function updateSubmitState() {
        if (submitBtn) submitBtn.disabled = validate().length > 0;
      }

      // A disabled button never fires its own click event, so the button
      // sets pointer-events: none (see nosh-base.css) and this wrapper
      // catches the click instead, to tell the visitor why nothing happened.
      if (submitRow && submitBtn) {
        submitRow.addEventListener("click", function () {
          if (!submitBtn.disabled) return;
          hint.textContent = i18n.fillAllRequired || "Please fill in all required fields.";
          hint.classList.add("error");
        });
      }

      // Clear a field's highlight as soon as the visitor starts fixing it,
      // instead of making them re-submit before the error goes away.
      REQUIRED_FIELDS.forEach(field => {
        const input = document.getElementById(field.id);
        if (input) {
          input.addEventListener("input", () => {
            setFieldError(input, false);
            updateSubmitState();
          });
        }
      });
      updateSubmitState();

      form.addEventListener("submit", function (e) {
        const missing = validate();
        if (missing.length) {
          e.preventDefault();
          REQUIRED_FIELDS.forEach(field => {
            const input = document.getElementById(field.id);
            if (input) setFieldError(input, missing.includes(field));
          });
          const addBeforeSendingTemplate = i18n.addBeforeSendingTemplate || "Please add FIELDS_PLACEHOLDER before sending.";
          hint.textContent = addBeforeSendingTemplate.replace("FIELDS_PLACEHOLDER", missing.map(field => field.label).join(", "));
          hint.classList.add("error");
          const firstMissingInput = document.getElementById(missing[0].id);
          if (firstMissingInput) firstMissingInput.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        REQUIRED_FIELDS.forEach(field => {
          const input = document.getElementById(field.id);
          if (input) setFieldError(input, false);
        });
        hint.classList.remove("error");
        bodyField.value = buildMessage();
        // no preventDefault — submits to Shopify's contact form handler
      });
    }
  });
})();
